<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <datepicker-input
          name="limitation_date"
          label="Limitation Date"
          helper="Please enter the limitation date"
          v-model="form.limitation_date"
        ></datepicker-input>

        <datepicker-input
          name="date_of_particulars"
          label="Date Of Particulars"
          helper="Please enter the date of particulars"
          v-model="form.date_of_particulars"
        ></datepicker-input>

        <datepicker-input
          name="proceedings_sent_for_issue"
          label="Proceedings Sent For Issue"
          helper="Please enter the proceedings date"
          v-model="form.proceedings_sent_for_issue"
        ></datepicker-input>

        <datepicker-input
          name="issued_date"
          label="Issued Date"
          helper="Please enter the issued date"
          v-model="form.issued_date"
        ></datepicker-input>

        <datepicker-input
          name="settled_date"
          label="Settled Date"
          helper="Please enter the settled date"
          v-model="form.settled_date"
        ></datepicker-input>

        <datepicker-input
          name="file_reopened_date"
          label="File Reopened Date"
          helper="Please enter the file reopened date"
          v-model="form.file_reopened_date"
        ></datepicker-input>

        <datepicker-input
          name="settlement_promised_date"
          label="Settlement Promised Date"
          helper="Please enter the settlement promised date"
          v-model="form.settlement_promised_date"
        ></datepicker-input>

        <input-block
          name="reason_for_file_closure"
          label="Reason For File Closure"
          helper="Please enter the reason for file closure"
          v-model="form.reason_for_file_closure"
          :show-error="form.errors.has('reason_for_file_closure')"
          :error-message="form.errors.get('reason_for_file_closure')"
        ></input-block>

        <input-block
          name="reason_not_litigated"
          label="Reason Not Litigated"
          helper="Please enter the reason not litigated"
          v-model="form.reason_not_litigated"
          :show-error="form.errors.has('reason_not_litigated')"
          :error-message="form.errors.get('reason_not_litigated')"
        ></input-block>
      </div>

      <div class="col-lg-6">
        <datepicker-input
          name="notice_of_issue"
          label="Notice Of Issue"
          helper="Please enter the date of notice of issue"
          v-model="form.notice_of_issue"
        ></datepicker-input>

        <datepicker-input
          name="defense_in_date"
          label="Defence In Date"
          helper="Please enter the date of defence in"
          v-model="form.defense_in_date"
        ></datepicker-input>

        <datepicker-input
          name="reply_to_defense_date"
          label="Reply To Defence Date"
          helper="Please enter the reply to defence date"
          v-model="form.reply_to_defense_date"
        ></datepicker-input>

        <datepicker-input
          name="impec_docs_date"
          label="Impec Docs Date"
          helper="Please enter the impec docs date"
          v-model="form.impec_docs_date"
        ></datepicker-input>

        <datepicker-input
          name="impec_docs_review_date"
          label="Impec Docs Reviewed Date"
          helper="Please enter the impec docs review date"
          v-model="form.impec_docs_review_date"
        ></datepicker-input>

        <datepicker-input
          name="hearing_date"
          label="Hearing Date"
          helper="Please enter the hearing date"
          v-model="form.hearing_date"
        ></datepicker-input>

        <inputbox
          name="counsel_name"
          label="Counsel Name"
          helper="Please enter the counsel name"
          v-model="form.counsel_name"
          :show-error="form.errors.has('counsel_name')"
          :error-message="form.errors.get('counsel_name')"
        ></inputbox>

        <inputbox
          name="appointed_court"
          label="Appointed Court"
          helper="Please enter the appointed court"
          v-model="form.appointed_court"
          :show-error="form.errors.has('appointed_court')"
          :error-message="form.errors.get('appointed_court')"
        ></inputbox>

        <datepicker-input
          name="pre_trial_call_date"
          label="Pre-Trial Call Date"
          helper="Please enter the pre-trial call date"
          v-model="form.pre_trial_call_date"
        ></datepicker-input>

        <selectlist
          :options="trialOutcomeOptions"
          label="Trial Outcome"
          name="trial_outcome"
          helper="Please select the trial outcome"
          placeholder="Please Select"
          label-name="label"
          key-name="id"
          v-model="form.trial_outcome"
          :show-error="form.errors.has('trial_outcome')"
          :error-message="form.errors.get('trial_outcome')"
        ></selectlist>
      </div>
    </div>

    <div class="text-right mt-3">
      <form-button :indicator="processing" @clicked="submit">Save</form-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    section: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      processing: false,
      form: new window.Form({
        limitation_date: null,
        date_of_particulars: null,
        proceedings_sent_for_issue: null,
        issued_date: null,
        settled_date: null,
        file_reopened_date: null,
        settlement_promised_date: null,
        reason_for_file_closure: null,
        reason_not_litigated: null,
        notice_of_issue: null,
        defense_in_date: null,
        reply_to_defense_date: null,
        impec_docs_date: null,
        impec_docs_review_date: null,
        hearing_date: null,
        counsel_name: null,
        appointed_court: null,
        pre_trial_call_date: null,
        trial_outcome: null
      }),
      dateFields: [
        'limitation_date',
        'date_of_particulars',
        'proceedings_sent_for_issue',
        'issued_date',
        'settled_date',
        'file_reopened_date',
        'settlement_promised_date',
        'notice_of_issue',
        'defense_in_date',
        'reply_to_defense_date',
        'impec_docs_date',
        'impec_docs_review_date',
        'hearing_date',
        'pre_trial_call_date'
      ],
      trialOutcomeOptions: [
        { id: 'win', label: 'Win' },
        { id: 'loss', label: 'Loss' }
      ]
    };
  },

  watch: {
    section: {
      handler: 'hydrate',
      immediate: true
    }
  },

  methods: {
    hydrate(d) {
      if (!d) {
        return;
      }

      // The api returns the dates as utc iso strings, so parse them back into
      // date objects to keep the datepickers in the users local timezone.
      this.dateFields.forEach(field => {
        this.form[field] = d[field] ? window.DateManager.parse(d[field]) : null;
      });

      this.form.reason_for_file_closure = d.reason_for_file_closure;
      this.form.reason_not_litigated = d.reason_not_litigated;
      this.form.counsel_name = d.counsel_name;
      this.form.appointed_court = d.appointed_court;
      this.form.trial_outcome = d.trial_outcome;
    },

    submit() {
      this.processing = true;

      this.form
        .put(`/debt-recovery/${this.incident}/keydates`)
        .then(data => {
          this.processing = false;
          this.form.errors.clear();
          this.$emit('saved', data);
          window.toastify.success(
            'Success!',
            'The key dates were saved successfully!'
          );
        })
        .catch(() => {
          this.processing = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the key dates'
          );
        });
    }
  }
};
</script>
